export default "__VITE_ASSET__DaFUslo4__"